"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SINGLE_PRODUCT = void 0;

var _availability = require("./availability");

var _inventoryHistory = require("./inventoryHistory");

var _inventoryOverview = require("./inventoryOverview");

var _inventoryParLevel = require("./inventoryParLevel");

var _productInfo = require("./productInfo");

var _tierPricing = require("./tierPricing");

var SINGLE_PRODUCT = {
  AVAILABILITY: _availability.AVAILABILITY,
  INVENTORY_HISTORY: _inventoryHistory.INVENTORY_HISTORY,
  INVENTORY_OVERVIEW: _inventoryOverview.INVENTORY_OVERVIEW,
  INVENTORY_PAR_LEVEL: _inventoryParLevel.INVENTORY_PAR_LEVEL,
  PRODUCT_INFO: _productInfo.PRODUCT_INFO,
  TIER_PRICING: _tierPricing.TIER_PRICING
};
exports.SINGLE_PRODUCT = SINGLE_PRODUCT;